import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const Card = styled.div`
  background-color: ${themeGet('colors.white')};
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 2rem 2rem 5.5rem;
  border-radius: 0.75rem;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  text-align: ${({ textAlignment }) => textAlignment || 'left'};
  gap: 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 2.5rem 2.25rem 5.5rem;
  }
`;

export const Heading = styled.h2`
  position: relative;
  font-weight: 600;
  font-size: 1.5rem;
`;

export const Subheading = styled.p``;

export const Icon = styled(Image)`
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  object-fit: contain;
  max-width: 3.25rem;
  max-height: 3.25rem;
  width: 100%;
  height: 100%;
`;

export const CardFooter = styled.div`
  position: absolute;
  bottom: 2.5rem;
`;

export const BottomCopy = styled.p``;
